import React from "react";
import { Tooltip } from "antd";
import { Pencil, Trash } from "assets/icons";
import { IColumn } from "typings/global";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

interface IColumnsTable {
  handleClickEditReaderAntenna: (id: number) => void;
  handleClickDeleteReader: (id: number) => void;
}

const ColumnsTable = ({ handleClickEditReaderAntenna, handleClickDeleteReader }: IColumnsTable) => {
  const UNIT = useTranslation({ id: "unit" });
  const READER_NUMBER = useTranslation({ id: "reader_number" });
  const READER_NAME = useTranslation({ id: "reader_name" });
  const READER_IP = useTranslation({ id: "reader_ip" });
  const CONFIG_ID = useTranslation({ id: "config_id" });
  const MODEL = useTranslation({ id: "model" });
  const PORT = useTranslation({ id: "port" });
  const PROTOCOL = useTranslation({ id: "protocol" });
  const STATUS = useTranslation({ id: "status" });
  const ACTIVE = useTranslation({ id: "active" });
  const INACTIVE = useTranslation({ id: "inactive" });
  const ACTION = useTranslation({ id: "action" });
  const READER_EDITING = useTranslation({ id: "reader_edit" });
  const DELETE_READER = useTranslation({ id: "delete_reader" });

  const collums: Array<IColumn> = [
    {
      title: UNIT,
      dataIndex: "locationDescription",
      filterMultiple: false,
      render: (locationDescription: string) => locationDescription || "--",
      width: "20%",
      key: "locationDescription",
    },
    {
      title: READER_NUMBER,
      dataIndex: "readerNumber",
      filterMultiple: false,
      render: (readerNumber: string) => readerNumber || "--",
      width: "10%",
      key: "readerNumber",
    },
    {
      title: READER_NAME,
      dataIndex: "readerName",
      filterMultiple: false,
      render: (readerName: string) => readerName || "--",
      width: "8%",
      key: "readerName",
    },
    {
      title: READER_IP,
      dataIndex: "readerIp",
      render: (readerIp: string) => readerIp || "--",
      width: "8%",
      key: "readerIp",
    },
    {
      title: CONFIG_ID,
      dataIndex: "configId",
      filterMultiple: false,
      render: (configId: string) => configId || "--",
      width: "9%",
      key: "configId",
    },
    {
      title: MODEL,
      dataIndex: "modelDescription",
      filterMultiple: false,
      render: (modelDescription: string) => modelDescription || "--",
      width: "10%",
      key: "modelDescription",
    },
    {
      title: PORT,
      dataIndex: "port",
      filterMultiple: false,
      render: (port: string) => port || "--",
      width: "5%",
      key: "port",
    },
    {
      title: PROTOCOL,
      dataIndex: "protocol",
      filterMultiple: false,
      render: (protocol: string) => protocol || "--",
      width: "10%",
      key: "protocol",
    },
    {
      title: STATUS,
      dataIndex: "status",
      filterMultiple: false,
      render: (status) => (status ? ACTIVE : INACTIVE),
      width: "8%",
      key: "status",
    },
    {
      title: ACTION,
      dataIndex: "readerEdit",
      width: "auto",
      key: "readerEdit",
      render: (_, record) => (
        <S.ActionContainer>
          <button aria-label={READER_EDITING} onClick={() => handleClickEditReaderAntenna(record.id)}>
            <Tooltip placement="top" title={READER_EDITING}>
              <Pencil className="pencilEdit" data-testid="editItemTable" />
            </Tooltip>
          </button>
          <button onClick={() => handleClickDeleteReader(record.id)}>
            <Tooltip placement="top" title={DELETE_READER}>
              <Trash className="trashIcon" data-testid="deleteReader" />
            </Tooltip>
          </button>
        </S.ActionContainer>
      ),
    },
  ];
  return collums;
};

export default ColumnsTable;
